import React, { useState } from 'react';
import classNames from 'classnames';
import Form from 'react-bootstrap/Form';

import Tooltip from 'ui-kit/tooltip/tooltip';

import './style.scss';

const Text = ({
    className,
    defaultValue,
    errors,
    footNote,
    icon,
    label,
    name,
    onChange,
    showErrorsText = true,
    style,
    touched,
    tooltipText,
    type = 'text',
    value,
    disabled = false
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const handleOnFocus = () => {
        setIsFocused(true);
    };
    const handleOnBlur = () => {
        setIsFocused(false);
    };

    const classes = classNames(
        'text',
        { focused: isFocused },
        { 'has-value': value || defaultValue },
        { 'has-errors': touched && errors }
    );

    const textLabelClasses = classNames('text-label', { reduced: label.length > 40 });

    return (
        <div className={classes} style={style}>
            <div className="text-input-container">
                {label && <Form.Label className={textLabelClasses}>{label}</Form.Label>}
                <Form.Control
                    className={`text-input ${className} ${disabled ? 'disabled' : ''}`}
                    type={type}
                    name={name}
                    onChange={onChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    defaultValue={defaultValue}
                    disabled={disabled}
                />
                {tooltipText && <Tooltip tip={tooltipText} />}
                {icon}
            </div>
            {touched && errors && showErrorsText && <div className="text-errors">{errors}</div>}
            {footNote && <div className="text-footnote">{footNote}</div>}
        </div>
    );
};

export default Text;
